var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Credit-Card--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Credit Card Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21 0H6a3 3 0 0 0 -3 3v4.5a1 1 0 0 0 1 1 1 1 0 0 0 1 -1v-0.25A0.25 0.25 0 0 1 5.25 7h16.5a0.25 0.25 0 0 1 0.25 0.25V12a1 1 0 0 1 -0.54 0.89 0.92 0.92 0 0 0 -0.46 0.84 1 1 0 0 0 1.45 0.9A3 3 0 0 0 24 12V3a3 3 0 0 0 -3 -3ZM5.25 4A0.25 0.25 0 0 1 5 3.75V3a1 1 0 0 1 1 -1h15a1 1 0 0 1 1 1v0.75a0.25 0.25 0 0 1 -0.25 0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10H2a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h15a2 2 0 0 0 2 -2V12a2 2 0 0 0 -2 -2ZM6 15.5a0.5 0.5 0 0 1 -0.5 0.5h-2a0.5 0.5 0 0 1 -0.5 -0.5v-2a0.5 0.5 0 0 1 0.5 -0.5h2a0.5 0.5 0 0 1 0.5 0.5Zm8.5 5.5a2 2 0 0 1 -1.33 -0.51 0.27 0.27 0 0 0 -0.34 0 2 2 0 0 1 -1.33 0.51 2 2 0 0 1 0 -4 2 2 0 0 1 1.33 0.51 0.26 0.26 0 0 0 0.34 0A2 2 0 0 1 14.5 17a2 2 0 0 1 0 4Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCard);
export default ForwardRef;